import { useEffect, useRef, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthenticationService from '../lib/auth';
import { Toaster } from '../components/ui/toaster';

// Import pages and layouts
import AuthenticationLayout from '../app/authentication/layout';
import SignIn from '../app/authentication/sign-in/page';
import Verify from '../app/authentication/verify/page';
import DashboardLayout from '../app/dashboard/layout';
import Organizations from '../app/dashboard/organizations/page';
import OrganizationLayout from '../app/dashboard/organizations/[id]/layout';
import Organization from '../app/dashboard/organizations/[id]/page';
import KnowledgeManagement from '../app/dashboard/organizations/[id]/knowledge-management/page';
import Users from '../app/dashboard/users/page';
import StaffList from '../app/dashboard/staff/page';
import StaffUserDetail from '../app/dashboard/staff/[id]/page';
import SearchSynonyms from '../app/dashboard/search-synonyms/page';

export default function App() {
  const [isReady, setReady] = useState(false);
  const isInitiated = useRef(false);

  useEffect(() => {
    const init = async () => {
      await AuthenticationService.init();
      setReady(true);
    };

    if (!isInitiated.current) {
      console.log('Initiating...');
      isInitiated.current = true;
      init();
    }
  }, []);

  if (!isReady) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background font-sans antialiased">
      <Routes>
        {/* Redirects */}
        <Route path="/" element={<Navigate to="/authentication/sign-in" replace />} />
        <Route path="/authentication" element={<Navigate to="/authentication/sign-in" replace />} />

        {/* Authentication routes with layout */}
        <Route path="/authentication" element={<AuthenticationLayout />}>
          <Route path="sign-in" element={<SignIn />} />
          <Route path="verify" element={<Verify />} />
        </Route>

        {/* Dashboard routes */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Navigate to="/dashboard/organizations" replace />} />
          <Route path="organizations" element={<Organizations />} />
          <Route path="organizations/:id" element={<OrganizationLayout />}>
            <Route index element={<Organization />} />
            <Route path="knowledge-management" element={<KnowledgeManagement />} />
          </Route>
          <Route path="users" element={<Users />} />
          <Route path="staff" element={<StaffList />} />
          <Route path="staff/:id" element={<StaffUserDetail />} />
          <Route path="search-synonyms" element={<SearchSynonyms />} />
        </Route>

        {/* Catch-all for unknown routes */}
        <Route path="*" element={<Navigate to="/authentication/sign-in" replace />} />
      </Routes>
      <Toaster />
    </div>
  );
}
